import React from "react";
import { Machine } from "../../backend/model";
import { Input } from "@progress/kendo-react-inputs";
import { EditDialog } from "../edit-dialog";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { machineSelectors } from "../../store/machineSlice";

interface MachineEditDialogProps {
  itemInEdit: Machine | any;
  setItemInEdit: (value: Machine | any) => void;
  onDelete: (value: Machine) => void;
  onEdit: (value: Machine) => void;
}

export const MachineEditDialog: React.FunctionComponent<
  MachineEditDialogProps
> = (props) => {
  const postPending = useSelector(machineSelectors.selectPostRequestPending());

  const { t } = useTranslation();

  const updateMachine = (u: Partial<Machine>) =>
    props.setItemInEdit((p: any) => ({ ...p, ...u }));

  const saveItem = () => {
    if (props.itemInEdit) {
      props.onEdit(props.itemInEdit);
      props.setItemInEdit(undefined);
    }
  };

  const deleteItem = () => {
    if (props.itemInEdit) {
      props.onDelete(props.itemInEdit);
      props.setItemInEdit(undefined);
    }
  };

  const cancel = () => {
    props.setItemInEdit(undefined);
  };

  const doValidate = () => {
    return postPending || props.itemInEdit
      ? props.itemInEdit.name === "" || props.itemInEdit.name.trim() === ""
      : false;
  };

  return (
    <EditDialog
      save={saveItem}
      validate={doValidate}
      delete={deleteItem}
      cancel={cancel}
    >
      <div className="kserv-dialog-container">
        <div className="kserv-dialog-field">
          <legend className="kserv-dialog-legend">
            {t("machine.editMachine")}
          </legend>
          <div className="kserv-dialog-item">
            <label>
              {t("machine.name")} <br />
              <Input
                type="text"
                autoFocus
                value={props.itemInEdit.name}
                minLength={1}
                onChange={(e) => {
                  const v =
                    e.target.value !== undefined
                      ? e.target.value + ""
                      : e.target.value;
                  updateMachine({ name: v });
                }}
              />
            </label>
          </div>
        </div>
      </div>
    </EditDialog>
  );
};
